import { Button, Link, Stack, Typography } from "@mui/material";
import CustomInput from "../../components/CustomInput";

const CustomTextArea = (props) => (
  <textarea
    style={{
      border: "1px solid #ddd",
      width: "100%",
      minHeight: 240,
      padding: 8,
      borderRadius: 8,
      outline: "1px solid #aaa"
    }}
    {...props}
  />
);

export default function GoogleAnalytics() {
  return (
    <div
      style={{
        maxWidth: "90%",
        margin: "auto"
      }}
    >
      <Typography variant="h3">Google Analytics Integration</Typography>
      <Stack direction="row">
        <Typography mr={1} variant="body1">Google Site Verification</Typography>
        <small>eg. KrxuEPKzDx7l1LD1v5LvXWf5raFEqUVYSOjYpR19v0</small>
      </Stack>
      <CustomInput placeholder="Google Site Verification Code" />
      <small>This helps you verify your site ownership.</small>
      <br />
      <Link href="#">Learn More</Link>
      <br />
      <br />
      <Typography variant="body1">Google Analytics 4 Code</Typography>
      <CustomTextArea placeholder="Code to be placed in <head> tag" />
      <small>
        The following events data is sent with this integration: view_item,
        add_to_cart, begin_checkout, add_paymnet_info, purchase,
        remove_from_cart.
      </small>
      <br />
      <Link href="#">Learn More</Link>
      <br />
      <br />
      <Typography variant="body1">Google Universal Analytics Code</Typography>
      <CustomTextArea placeholder="Code to be placed in <head> tag" />
      <small>
        This is the deprecated method of using Google Analytics. If you are
        setting analytics for the first time, we recommend using Google
        Analytics 4.
      </small>
      <Stack direction="row" justifyContent="end">
        <Button sx={{ marginBlock: 2 }} variant="contained">
          Save
        </Button>
      </Stack>
    </div>
  );
}
